import { StateParams } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { IFieldArray } from "AngularFormly";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../../app/records/server/serverUtility";
import { Contract } from "../../../../shared/models/contract";
import { ContractConfiguration } from "../../../../shared/models/contractConfiguration";

import { IQuery } from "../../../../../records/server/query";
const gridId = Symbol("main.contract.master");
export class GamingContractMasterDetailController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
  ];
  model!: any;
  formFields!: IFieldArray;
  contract!: Contract<ContractConfiguration>;
  currentConfiguration: ContractConfiguration | undefined;
  contractType!: string;

  readonly defaultQuery: IQuery = {};

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility
  ) {}

  $onInit(): void {}
}
